import React, { useRef, forwardRef } from 'react';
import { useButton } from 'react-aria';
import classNames from 'classnames';

const Button = forwardRef(function Button(props, forwardedRef) {
  // function Button(props) {
  const {
    theme,
    type,
    size,
    title,
    ariaLabel,
    ariaPressed,
    ariaExpanded,
    isDisabled,
    onPress,
    asLink,
    isLoading,
    iconType,
    iconPosition,
    themes,
    className,
    children,
    style,
    ...otherProps
  } = props;

  // Buttons should use a forwarded ref else use its own.
  // https://react.dev/reference/react/forwardRef
  const buttonRef = useRef(null);
  const ref = forwardedRef || buttonRef;

  const { buttonProps } = useButton(
    {
      ...props,
      // Remove focus styles affecting clicking and dragging for #13173.
      // https://dev.azure.com/ccdg/CWO%20-%20Events/_workitems/edit/13173
      preventFocusOnPress: true,
      // Workaround for issue #5802
      // https://github.com/adobe/react-spectrum/issues/5802
      // https://github.com/adobe/react-spectrum/issues/1513#issuecomment-1928903517
      onPress(e) {
        if (e.pointerType === 'mouse' || e.pointerType === 'keyboard') {
          props.onPress?.(e);
          return;
        }

        setTimeout(() => {
          props.onPress?.(e);
        }, 1);
      }
    },
    ref
  );

  const buttonClasses = classNames('button', className, {
    ['button--' + theme]: theme,
    ['button--' + size]: size,
    'button--as-link': asLink,
    'button--spinner': isLoading,
    'button--disabled': !asLink ? isDisabled || isLoading : isDisabled,
    'button--icon': iconType,
    ['icon--' + iconType]: iconType,
    ['icon--' + iconPosition]: iconPosition
  });

  return (
    <button
      ref={ref}
      {...buttonProps}
      disabled={isDisabled ? true : false}
      style={style}
      className={buttonClasses}
      title={title}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
      aria-expanded={ariaExpanded}
    >
      {children}
    </button>
  );
  // }
});

export default Button;
